import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {
  Box,
  Button,
  Container,
  Divider,
  FormControl,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { styled } from "@mui/system";
import { useFormik } from "formik";
import { KeyboardEvent, useState } from "react";
import { useAppDispatch } from "../../Redux/hooks";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import * as Yup from "yup";
import { login } from "../../Redux/authSlice";
import { startBlocking } from "../../Redux/loadingSlice";
import { fetchUserCurrency } from "../../Redux/currencySlice";
import { UrlConstant } from "../../commom/UrlConstant";
import Axios from "../../config/axios";
import "../../style/style.css";
import LeftSide from "../common/Layout/LeftSide";
import Footer from "../common/Layout/Footer";
import Successpopup from "../common/SharedComponent/Successpopup";
import investOnYourTerm from "../../style/images/invest-on-your-term.svg";

interface FormValues {
  email: string;
  password: string;
}

function Login() {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [isLogin, setIsLogin] = useState<boolean>(false);
  const [showPopup, setShowPopup] = useState(false); // State for controlling popup visibility
  const [Success, setSuccess] = useState(false); // State for controlling popup visibility
  const [msg, setmsg] = useState(""); // State for controlling popup visibility
  const [heading, setheading] = useState(""); // State for controlling popup visibility

  const initialValues: FormValues = {
    email: "",
    password: "",
  };
  const dispatch = useAppDispatch();
  const navigation = useNavigate();

  const keyup = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.code === "Enter") {
      formik.handleSubmit();
    }
  };

  const onSubmit = async (values: FormValues) => {
    dispatch(startBlocking());
    const data = {
      email: values.email?.toLocaleLowerCase(),
      password: values.password,
    };

    try {
      const response = await Axios.post(UrlConstant.Auth.Login, data);
      const resData = response.data;
      if (resData.result === true) {
        dispatch(login(resData.data));
        await dispatch(fetchUserCurrency());

        setTimeout(() => {
          // if (resData.data?.isPhoneVerify === false) {
          //   navigation("/phone-verification", {
          //     state: {
          //     user: response?.data?.data,
          //     },
          //   });
          // } else
          if (resData.data?.isVerify === false) {
            navigation("/otp", { state: { email: resData.data.email, id: resData.data._id } });
          } else if (resData.data?.acceptDisclosure === false) {
            navigation("/terms", { state: resData.data });
          } else if (resData.data?.IsPINCreated === false) {
            navigation("/createpin", { state: resData.data });
          } else {
            navigation("/", { state: resData.data });
          }
        }, 100);
      } else {
        // Swal.fire(resData.msg ?? "Authentication Failed");
        setheading("ERROR");
        setShowPopup(true);
        setmsg(resData.msg ?? "Authentication Failed");
      }
    } catch (error: any) {
      console.error("ERRR : ", error);
      // Swal.fire(error.response.data.msg ?? "Authentication Failed");
      setShowPopup(true);
      setheading("Error");
      setmsg(error.response.data.msg ?? "Authentication Failed");
    }
  };

  const validationSchema = Yup.object({
    email: Yup.string().email("valid format").required("Email is required"),
    password: Yup.string()
      .min(8, "Password must be at least 8 characters long")
      .required("Password is required"),
  });

  const formik = useFormik<FormValues>({
    initialValues,
    onSubmit,
    validationSchema,
  });
  const closePopup = () => {
    setShowPopup(false); // Function to close the popup
  };

  return (
    <Box height="100vh" className='bg-black'>
      <Container
        maxWidth={false}
        className="container_new"
        sx={{ maxWidth: "100%", margin: "0px" }}
      >
        {/* <LeftSide /> */}

        <Box
          width="100%"
          // className="bg-color"
          padding={{ xs: "0px", xl: "60px" }}
          minHeight="100vh"
          display="flex"
          alignItems="center"
        >
          <RightSection className="RightSection">
            {/* Dream BIG, LIVE Large Section */}
            {/* <img 
                src={investOnYourTerm} 
                alt="Invest on your terms" 
                style={{ 
                  maxWidth: '240px', 
                  height: 'auto',
                  marginBottom: '24px'
                }} 
              /> */}
            <Box sx={{
              // textAlign: 'center', 
              mb: 2,
              mt: 0,
            }}>
              <Typography variant="h2" sx={{
                fontWeight: 700,
                color: 'white',
                marginBottom: '24px',
                margin: 0
                // lineHeight: 1.2,
              }}>
                Invest Now <br /> <span className="gradient-text">Pay Later</span>
              </Typography>
              <Typography variant="body1" sx={{
                fontSize: '24px',
                color: 'white',
                fontWeight: 'medium',
              }}>
                With Booster Loans
              </Typography>
            </Box>

            <Typography width="100%">
              {/* <Typography
                className="Typography fw-700 fs-24 fs-24-desktop heading"
                width="100%"
                sx={{
                  fontSize: '24px',
                  fontWeight: 700,
                  color: 'white',
                  marginBottom: '24px',
                  lineHeight: 1.2,
                }}
              >
                Welcome back to Wolfpack
              </Typography> */}
              {/* <Typography
                className="Typography fs-18 fs-18-desktop mb-50 text-secondary"
                variant="body1"
                sx={{ 
                  fontSize: '14px',
                  color: 'rgba(255, 255, 255, 0.7)',
                  marginBottom: '24px',
                  lineHeight: 1.4
                }}
              >
                Your world awaits—let's pick up where you left off.
              </Typography> */}
            </Typography>
            <Box
              sx={{
                p: '2px',
                borderRadius: '16px',
                background: 'linear-gradient(135deg, #FF6A00 0%, #FF2D95 40%, #7B2CFF 70%, rgb(43, 12, 253) )',
              }}
            >
              <Box className="w-100 p-4 d-flex flex-column bg-color"
                sx={{
                  borderRadius: '14px',
                  height: '100%',
                }}
              >
                <form onSubmit={formik.handleSubmit}>
                  <Box width="100%">
                    <FormControl fullWidth margin="normal" sx={{ mb: 2 }}>
                      <TextField
                        // name="EmailId"
                        label={
                          <span>
                            Email ID{" "}
                            <sup>
                              <i
                                className="fa-solid fa-star-of-life"
                                style={{ color: "#fa0000", fontSize: "0.5rem" }}
                              ></i>
                            </sup>
                          </span>
                        }
                        onKeyUp={keyup}
                        variant="outlined"
                        className="text-secondary "
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: 'rgba(255, 255, 255, 0.05)',
                            borderRadius: '8px',
                            height: '48px',
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'rgba(255, 255, 255, 0.3)',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#F2674A',
                            },
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: `${formik.errors.email && isLogin ? "red !important" : "rgba(255, 255, 255, 0.2)"
                              } `,
                          },
                          "& .MuiInputLabel-root": {
                            color: 'rgba(255, 255, 255, 0.7)',
                            fontSize: '14px',
                            '&.Mui-focused': {
                              color: '#F2674A',
                            },
                          },
                          "& .MuiOutlinedInput-input": {
                            color: 'white',
                            padding: '12px 14px',
                            fontSize: '14px',
                          },
                        }}
                        slotProps={{
                          input: {
                            startAdornment: (
                              <IconButton sx={{ background: "transparent" }}>
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M7 20.5C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5H7Z"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M17 9L13.87 11.5C12.84 12.32 11.15 12.32 10.12 11.5L7 9"
                                    stroke="white"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </IconButton>
                            ),
                          },
                        }}
                        InputLabelProps={{
                          shrink: false,
                        }}
                        {...formik.getFieldProps("email")}
                      />
                      {isLogin && formik.errors.email ? (
                        <Typography className="error ">
                          {formik.errors.email}
                        </Typography>
                      ) : null}
                    </FormControl>

                    <FormControl fullWidth margin="normal" sx={{ mb: 1.5 }}>
                      <TextField
                        // name="Password"
                        label={
                          <span>
                            Password{" "}
                            <sup>
                              <i
                                className="fa-solid fa-star-of-life"
                                style={{ color: "#fa0000", fontSize: "0.5rem" }}
                              ></i>
                            </sup>
                          </span>
                        }
                        type={showPassword ? "text" : "password"}
                        variant="outlined"
                        className="text-secondary "
                        onKeyUp={keyup}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: 'rgba(255, 255, 255, 0.05)',
                            borderRadius: '8px',
                            height: '48px',
                            '&:hover .MuiOutlinedInput-notchedOutline': {
                              borderColor: 'rgba(255, 255, 255, 0.3)',
                            },
                            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                              borderColor: '#F2674A',
                            },
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: `${formik.errors.password && isLogin
                              ? "red !important"
                              : "rgba(255, 255, 255, 0.2)"
                              } `,
                          },
                          "& .MuiInputLabel-root": {
                            color: 'rgba(255, 255, 255, 0.7)',
                            fontSize: '14px',
                            '&.Mui-focused': {
                              color: '#F2674A',
                            },
                          },
                          "& .MuiOutlinedInput-input": {
                            color: 'white',
                            padding: '12px 14px',
                            fontSize: '14px',
                          },
                        }}
                        size="medium"
                        InputProps={{
                          startAdornment: (
                            <IconButton>
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6 10V8C6 4.69 7 2 12 2C17 2 18 4.69 18 8V10"
                                  stroke="white"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M7 22C3 22 2 21 2 17V15C2 11 3 10 7 10H17C21 10 22 11 22 15V17C22 21 21 22 17 22H7Z"
                                  stroke="white"
                                  stroke-width="1.5"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M15.9965 16H16.0054"
                                  stroke="white"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M11.9955 16H12.0045"
                                  stroke="white"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                                <path
                                  d="M7.99451 16H8.00349"
                                  stroke="white"
                                  stroke-width="2"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                />
                              </svg>
                            </IconButton>
                          ),
                          endAdornment: (
                            <IconButton
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              <IconButton
                                onClick={() => setShowPassword(!showPassword)}
                              >
                                {showPassword ? (
                                  <VisibilityOutlinedIcon />
                                ) : (
                                  <VisibilityOffOutlinedIcon />
                                )}
                              </IconButton>
                            </IconButton>
                          ),
                        }}
                        InputLabelProps={{
                          shrink: false,
                        }}
                        {...formik.getFieldProps("password")}
                      />
                      {isLogin && formik.errors.password ? (
                        <Typography className="error ">
                          {formik.errors.password}
                        </Typography>
                      ) : null}
                      <Link
                        to="/forgot"
                        className="link"
                        style={{
                          textAlign: "end",
                          marginTop: "10px",
                          color: '#4A7AF2',
                          textDecoration: 'none',
                          fontSize: '14px',
                          fontWeight: 500,
                        }}
                      >
                        Forgot Password?
                      </Link>
                    </FormControl>

                    <Button
                      variant="contained"
                      // color="primary"
                      fullWidth
                      // className="btn-primary fw-700 btn-padding  btn mb-10"
                      className="gradient-main"
                      sx={{
                        fontSize: "14px",
                        paddingY: "14px",
                        // backgroundColor: '#F2674A',
                        borderRadius: '18px',
                        textTransform: 'none',
                        fontWeight: 700,
                        height: '48px',
                        // marginTop: '20px',
                        // '&:hover': {
                        //   backgroundColor: '#e55a3a',
                        // },
                      }}
                      endIcon={
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.4399 14.62L19.9999 12.06L17.4399 9.5"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M9.76001 12.0601H19.93"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M11.76 20C7.34001 20 3.76001 17 3.76001 12C3.76001 7 7.34001 4 11.76 4"
                            stroke="white"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      }
                      type="submit"
                      onClick={() => setIsLogin(true)}
                    >
                      Log In
                    </Button>
                  </Box>
                </form>

                <Divider
                  className="w-100 mt-2 p-2"
                  sx={{
                    color: '#6c757d',
                    '&::before, &::after': {
                      borderColor: '#6c757d',
                    },
                  }}
                >
                  or
                </Divider>            {/* <Typography sx={{fontSize: '18px', padding: '10px'}} className="text-secondary mt-2 d-flex align-items-center justify-content-center border w-100"> */}
                {/* </Typography> */}

                <Box className="w-100  d-flex align-items-center justify-content-center p-2 mt-2">
                  <Typography className="text-secondary">
                    Don't have an account? &nbsp;{" "}
                    <Link
                      to="/signup"
                      className="link"
                      style={{
                        color: '#4A7AF2',
                        textDecoration: 'none',
                        fontWeight: 500,
                      }}
                    >
                      Sign Up
                    </Link>
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                mt: 2,
                width: "100%",
              }}
            >
              <Box
                component="a"
                href="https://play.google.com/store/apps/details?id=inc.financial.wolfpack"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.2,
                  px: 2.2,
                  py: 1.3,
                  flex: 1,
                  maxWidth: 195,
                  backdropFilter: "blur(6px)",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    transform: "translateY(-3px)",
                    boxShadow: "0 12px 28px rgba(0,0,0,0.45)",
                  },
                }}
              >
                <img
                  src={'https://mmfiles.s3.ap-southeast-2.amazonaws.com/ProjectFiles/Group%202.png-7b4ff4d7-ae9a-4efa-b5e8-629ed9a0d4fa'}
                  alt="Get it on Google Play"
                  style={{ height: 50, width: "auto", display: "block", }}
                />
              </Box>

              <Box
                component="a"
                href="https://apps.apple.com/in/app/wolfpack-financial/id1610870346"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1.2,
                  px: 2.2,
                  py: 1.3,
                  textDecoration: "none",
                  flex: 1,
                  maxWidth: 195,
                  backdropFilter: "blur(6px)",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    transform: "translateY(-3px)",
                    boxShadow: "0 12px 28px rgba(0,0,0,0.45)",
                  },
                }}
              >
                <img
                  src={'https://mmfiles.s3.ap-southeast-2.amazonaws.com/ProjectFiles/Group%201.png-06bccd93-27dc-42e6-bcb9-71c0272641cd'}
                  alt="Download on the App Store"
                  style={{ height: 50, width: "auto", display: "block" }}
                />
              </Box>
            </Box>
          </RightSection>
        </Box>
        {showPopup && (
          <Successpopup
            Heading={heading}
            Success={Success}
            onClose={closePopup}
            Message={msg}
          />
        )}
      </Container>
      {/* <Box className='bg-color' sx={{width:'100%', paddingBottom:'5px'}}><Footer/></Box> */}
    </Box>
  );
}

const RightSection = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "start",
  padding: "20px 40px",
  alignItems: "start",
  height: "100%",
  maxWidth: "600px",
  margin: "0 auto",
  [theme.breakpoints.down("xl")]: {
    padding: "20px 30px",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    padding: "20px 30px",
  },
  [theme.breakpoints.down("lg")]: {
    padding: "20px 30px",
  },
  [theme.breakpoints.down("sm")]: {
    padding: "20px 20px",
  },
}));

export default Login;
